import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../lib/settings";

const PAGES = {
  about: {
    title: "Chi siamo",
    body: (
      <>
        <p>Giochi.Gratis è il portale italiano dove puoi giocare gratis a migliaia di giochi online direttamente dal browser: niente download, niente registrazione.</p>
        <p>Trovi giochi di azione, corse, puzzle, sport, giochi per ragazze, per bambini e molto altro, aggiornati di continuo. Tutti i giochi sono in HTML5 e funzionano su computer, tablet e smartphone.</p>
        <p>Salva i tuoi giochi preferiti con il cuore e ritrova quelli giocati di recente nella sezione <Link to="/giocati">Giocati</Link>.</p>
      </>
    ),
  },
  terms: {
    title: "Termini di utilizzo",
    body: (
      <>
        <p>Utilizzando Giochi.Gratis accetti i presenti termini. Il sito offre l'accesso gratuito a giochi online forniti da terze parti (GameMonetize.com e relativi sviluppatori), che restano titolari dei diritti sui giochi.</p>
        <h2>Uso del servizio</h2>
        <p>Il servizio è fornito "così com'è". Non garantiamo la disponibilità continua dei giochi né la loro assenza di errori. È vietato qualsiasi uso illecito del sito.</p>
        <h2>Pubblicità</h2>
        <p>Il sito è gratuito grazie alla pubblicità mostrata nelle pagine e all'interno dei giochi.</p>
        <h2>Contatti</h2>
        <p>Per qualsiasi richiesta visita la pagina <Link to="/contatti">Contatti</Link>.</p>
      </>
    ),
  },
  privacy: {
    title: "Privacy e Cookie",
    body: (
      <>
        <p>Titolare del trattamento: [Ragione sociale / Nome titolare], [Indirizzo], email: [email di contatto].</p>
        <h2>Dati raccolti</h2>
        <p>Giochi.Gratis non richiede registrazione. I giochi preferiti e quelli giocati di recente sono salvati solo nel tuo browser (localStorage) e non vengono inviati ai nostri server.</p>
        <h2>Cookie di terze parti</h2>
        <p>Il sito utilizza servizi pubblicitari di terze parti (ad esempio Google AdSense e GameMonetize) che possono usare cookie per mostrare annunci personalizzati e misurarne l'efficacia. Puoi gestire le preferenze sugli annunci Google su <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">adssettings.google.com</a>.</p>
        <p>I giochi sono caricati da server esterni (GameMonetize.com) che possono impostare propri cookie.</p>
        <h2>I tuoi diritti</h2>
        <p>Ai sensi del GDPR puoi chiedere accesso, rettifica o cancellazione dei tuoi dati scrivendo a [email di contatto].</p>
      </>
    ),
  },
};

const PATHS = { about: "/chi-siamo", terms: "/termini", privacy: "/privacy" };

export function StaticPage({ kind }) {
  const p = PAGES[kind];
  useSeo({ title: p.title, path: PATHS[kind], description: kind === "about" ? "Giochi.Gratis è il portale italiano dove puoi giocare gratis a migliaia di giochi online direttamente dal browser: niente download, niente registrazione." : `${p.title} di Giochi.Gratis.` });
  return (
    <div className="bgs gg-static" data-testid={`static-page-${kind}`}>
      <h1>{p.title}</h1>
      {p.body}
    </div>
  );
}

export function ContactPage() {
  useSeo({ title: "Contatti", path: "/contatti", description: "Contatta Giochi.Gratis per domande, segnalazioni sui giochi o proposte di collaborazione." });
  return (
    <div className="bgs gg-static" data-testid="static-page-contact">
      <h1>Contatti</h1>
      <p>Hai una domanda, una segnalazione su un gioco o una proposta di collaborazione? Scrivici a: <b>[email di contatto]</b></p>
      <p>Per segnalare un gioco che non funziona, indica il nome del gioco e il dispositivo che stai usando.</p>
    </div>
  );
}

export function RandomGame() {
  const nav = useNavigate();
  useEffect(() => {
    api.get("/games-random").then((r) => nav(r.data?.slug ? `/gioco/${r.data.slug}` : "/", { replace: true })).catch(() => nav("/", { replace: true }));
  }, [nav]);
  return <div className="gg-empty"><i className="fa-solid fa-dice fa-spin" /> Scelgo un gioco per te...</div>;
}

export function NotFound() {
  const [s] = useState(0);
  useSeo({ title: "Pagina non trovata", noindex: true });
  return (
    <div className="gg-empty" data-testid="not-found-page" key={s}>
      <h1 style={{ fontSize: 60, fontFamily: "Oswald", color: "#fc0" }}>404</h1>
      <p>Pagina non trovata. <Link to="/">Torna alla home</Link></p>
    </div>
  );
}
